import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "calculator__skill tooltip-anchor" }
const _hoisted_2 = { class: "calculator__tooltip-desc-block" }
const _hoisted_3 = { class: "calculator__tooltip-desc" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "calculator__cost-block" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Перк класса")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TooltipComponent = _resolveComponent("TooltipComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TooltipComponent, {
      width: 25,
      color: 'dark',
      class: "calculator__tooltip"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.getSoldierData('id', _ctx.soldierClass, 'perk')), 1)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("img", {
      src: 
				require('@/assets/soldier_icons/' +
					_ctx.getSoldierData('id', _ctx.soldierClass, 'icon'))
			,
      alt: "",
      class: "calculator__img soldier-perk"
    }, null, 8, _hoisted_4),
    _hoisted_5
  ]))
}